import React from "react";
import { SVGIconProps } from "@/interface/icon.types";

const AccountDeletionIcon = ({ className }: SVGIconProps) => {
  return (
    <svg
      width="100%"
      height="172"
      viewBox="0 0 330 172"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      data-testid="account-deletion-icon"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M209.377 113H70.3019C64.3935 113 59.6038 108.209 59.6038 102.3C59.6038 96.3906 64.3935 91.6 70.3019 91.6H10.6981C4.78971 91.6 0 86.8094 0 80.9C0 74.9906 4.78971 70.2 10.6981 70.2H71.8302C77.7386 70.2 82.5283 65.4095 82.5283 59.5C82.5283 53.5906 77.7386 48.8 71.8302 48.8H33.6226C27.7142 48.8 22.9245 44.0094 22.9245 38.1C22.9245 32.1906 27.7142 27.4 33.6226 27.4H94.7547C88.8463 27.4 84.0566 22.6094 84.0566 16.7C84.0566 10.7906 88.8463 6 94.7547 6L181.868 6C187.776 6 192.566 10.7906 192.566 16.7C192.566 22.6094 187.776 27.4 181.868 27.4H279.679C285.588 27.4 290.377 32.1906 290.377 38.1C290.377 44.0094 285.588 48.8 279.679 48.8H313.302C319.21 48.8 324 53.5906 324 59.5C324 65.4095 319.21 70.2 313.302 70.2H284.264C278.356 70.2 273.566 74.9906 273.566 80.9C273.566 86.8094 278.356 91.6 284.264 91.6H293.434C299.342 91.6 304.132 96.3906 304.132 102.3C304.132 108.209 299.342 113 293.434 113H213.962C213.175 113 212.408 112.915 211.67 112.754C210.931 112.915 210.164 113 209.377 113Z"
        fill="#F8FAFC"
      ></path>
      <circle cx="319.5" cy="103.5" r="10.5" fill="#F8FAFC"></circle>
      <path
        d="M159.41 152C196.901 152 227.296 121.71 227.296 84.2158C227.296 46.7213 196.901 16.4321 159.41 16.4321C121.918 16.4321 91.5234 46.7213 91.5234 84.2158C91.5234 121.71 121.918 152 159.41 152Z"
        fill="#EAEEF9"
      ></path>
      <g filter="url(#filter0_d_910_24307)">
        <path
          d="M173.183 58.047C173.183 67.9735 165.127 76.001 155.079 76.001C154.906 76.001 153.434 76.001 142.606 76.001C135.071 76.001 123.03 76.001 103.801 76.001H94.6195C82.5795 76.26 72.9648 66.6787 72.9648 55.1122C72.9648 43.4593 82.6661 33.7918 94.8794 34.396C105.36 1.76797 153.347 6.3428 157.418 40.093C166.426 41.2151 173.183 48.811 173.183 58.047Z"
          fill="url(#paint0_linear_910_24307)"
        ></path>
      </g>
      <path
        d="M155.08 76.0009C165.041 76.0009 173.183 67.9733 173.183 58.0468C173.183 48.1203 165.041 40.0928 155.08 40.0928C145.119 40.0928 136.977 48.1203 136.977 58.0468C136.977 67.9733 145.119 76.0009 155.08 76.0009Z"
        fill="url(#paint1_linear_910_24307)"
      ></path>
      <path
        d="M125.542 76.1736C143.299 76.1736 157.765 61.8449 157.765 44.1498C157.765 26.4547 143.299 12.126 125.542 12.126C107.786 12.126 93.3203 26.4547 93.3203 44.1498C93.3203 61.8449 107.699 76.1736 125.542 76.1736Z"
        fill="url(#paint2_linear_910_24307)"
      ></path>
      <g filter="url(#filter1_d_910_24307)">
        <path
          d="M269.005 104.93C269.005 115.832 260.157 124.648 249.122 124.648C248.932 124.648 247.315 124.648 235.423 124.648C227.147 124.648 213.923 124.648 192.804 124.648H182.72C169.497 124.933 158.938 114.41 158.938 101.707C158.938 88.9085 169.592 78.2908 183.006 78.9544C194.517 43.1198 247.219 48.1442 251.691 85.2112C261.584 86.4436 269.005 94.7861 269.005 104.93Z"
          fill="url(#paint3_linear_910_24307)"
        ></path>
      </g>
      <path
        d="M249.121 124.648C260.061 124.648 269.003 115.832 269.003 104.93C269.003 94.0279 260.061 85.2114 249.121 85.2114C238.181 85.2114 229.238 94.0279 229.238 104.93C229.238 115.832 238.181 124.648 249.121 124.648Z"
        fill="url(#paint4_linear_910_24307)"
      ></path>
      <path
        d="M216.682 124.838C236.184 124.838 252.071 109.101 252.071 89.6671C252.071 70.233 236.184 54.4961 216.682 54.4961C197.18 54.4961 181.293 70.233 181.293 89.6671C181.293 109.101 197.085 124.838 216.682 124.838Z"
        fill="url(#paint5_linear_910_24307)"
      ></path>
      <g filter="url(#filter2_d_910_24307)">
        <path
          d="M157.773 127.151C157.773 133.355 152.738 138.372 146.458 138.372C146.35 138.372 145.43 138.372 138.663 138.372C133.953 138.372 126.428 138.372 114.409 138.372H108.671C101.146 138.534 95.1367 132.546 95.1367 125.317C95.1367 118.034 101.2 111.991 108.833 112.369C115.384 91.9764 145.376 94.8357 147.92 115.93C153.55 116.631 157.773 121.378 157.773 127.151Z"
          fill="url(#paint6_linear_910_24307)"
        ></path>
      </g>
      <path
        d="M146.455 138.372C152.681 138.372 157.77 133.355 157.77 127.15C157.77 120.946 152.681 115.929 146.455 115.929C140.229 115.929 135.141 120.946 135.141 127.15C135.141 133.355 140.229 138.372 146.455 138.372Z"
        fill="url(#paint7_linear_910_24307)"
      ></path>
      <path
        d="M127.994 138.48C139.092 138.48 148.133 129.525 148.133 118.465C148.133 107.406 139.092 98.4502 127.994 98.4502C116.896 98.4502 107.855 107.406 107.855 118.465C107.855 129.525 116.842 138.48 127.994 138.48Z"
        fill="url(#paint8_linear_910_24307)"
      ></path>
      <path
        d="M154.527 58.7828L145.696 65.8755C144.05 67.0994 141.9 66.2271 141.396 64.1311L138.449 43.7809"
        fill="#A5B0BE"
      ></path>
      <path
        d="M238.921 7.34837L233.248 12.58L173.868 67.7431C171.162 70.3277 166.977 70.2178 164.187 67.8361L142.855 48.2703L138.575 44.3047L126.776 33.2684C124.249 30.8242 125.402 26.3938 128.874 25.8427L226.472 9.76391L238.921 7.34837Z"
        fill="#CBD4E0"
      ></path>
      <path
        d="M238.922 7.34845L233.249 12.5801L143.055 47.9458L138.514 44.0428L226.673 9.43943L238.922 7.34845Z"
        fill="#A5B0BE"
      ></path>
      <path
        d="M74.5089 118.445L70.7274 121.653C70.0211 122.208 69.0697 121.851 68.8246 120.94L67.2943 112.067"
        fill="#A5B0BE"
      ></path>
      <path
        d="M110.845 94.9425L108.423 97.299L83.0825 122.14C81.9286 123.303 80.0956 123.304 78.8464 122.294L69.2779 113.98L67.3581 112.294L62.0633 107.602C60.9281 106.561 61.3807 104.609 62.8937 104.327L105.424 96.1457L110.845 94.9425Z"
        fill="#CBD4E0"
      ></path>
      <path
        d="M110.847 94.9428L108.425 97.2992L69.3633 113.836L67.3294 112.181L105.51 96.0015L110.847 94.9428Z"
        fill="#A5B0BE"
      ></path>
      <path
        d="M148.176 132.459L141.251 138.333C139.958 139.349 138.216 138.696 137.767 137.027L134.965 120.78"
        fill="#A5B0BE"
      ></path>
      <path
        d="M214.701 89.4264L210.266 93.7411L163.867 139.226C161.754 141.355 158.398 141.357 156.111 139.508L138.591 124.284L135.075 121.198L125.38 112.606C123.302 110.701 124.131 107.125 126.901 106.609L204.775 91.6294L214.701 89.4264Z"
        fill="#CBD4E0"
      ></path>
      <path
        d="M214.704 89.4262L210.269 93.7408L138.746 124.02L135.022 120.989L204.931 91.3648L214.704 89.4262Z"
        fill="#A5B0BE"
      ></path>
      <defs>
        <filter
          id="filter0_d_910_24307"
          x="50.9648"
          y="1.2041"
          width="144.219"
          height="107.802"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          ></feColorMatrix>
          <feOffset dy="11"></feOffset>
          <feGaussianBlur stdDeviation="11"></feGaussianBlur>
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
          ></feColorMatrix>
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_910_24307"
          ></feBlend>
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_910_24307"
            result="shape"
          ></feBlend>
        </filter>
        <filter
          id="filter1_d_910_24307"
          x="136.938"
          y="43.5815"
          width="154.066"
          height="114.072"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          ></feColorMatrix>
          <feOffset dy="11"></feOffset>
          <feGaussianBlur stdDeviation="11"></feGaussianBlur>
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
          ></feColorMatrix>
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_910_24307"
          ></feBlend>
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_910_24307"
            result="shape"
          ></feBlend>
        </filter>
        <filter
          id="filter2_d_910_24307"
          x="73.1367"
          y="87.499"
          width="106.637"
          height="83.8765"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          ></feColorMatrix>
          <feOffset dy="11"></feOffset>
          <feGaussianBlur stdDeviation="11"></feGaussianBlur>
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
          ></feColorMatrix>
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_910_24307"
          ></feBlend>
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_910_24307"
            result="shape"
          ></feBlend>
        </filter>
        <linearGradient
          id="paint0_linear_910_24307"
          x1="123.074"
          y1="38.5696"
          x2="123.041"
          y2="76.694"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white"></stop>
          <stop offset="0.9964" stopColor="#ECF0F5"></stop>
        </linearGradient>
        <linearGradient
          id="paint1_linear_910_24307"
          x1="135.05"
          y1="36.2273"
          x2="151.038"
          y2="53.7739"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BCCBE1"></stop>
          <stop offset="0.9942" stopColor="white" stopOpacity="0"></stop>
        </linearGradient>
        <linearGradient
          id="paint2_linear_910_24307"
          x1="90.303"
          y1="29.4549"
          x2="115.573"
          y2="39.3785"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E2E8F0"></stop>
          <stop offset="0.9942" stopColor="white" stopOpacity="0"></stop>
        </linearGradient>
        <linearGradient
          id="paint3_linear_910_24307"
          x1="213.971"
          y1="83.5382"
          x2="213.935"
          y2="125.409"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white"></stop>
          <stop offset="0.9964" stopColor="#ECF0F5"></stop>
        </linearGradient>
        <linearGradient
          id="paint4_linear_910_24307"
          x1="227.122"
          y1="80.9661"
          x2="244.681"
          y2="100.237"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BCCBE1"></stop>
          <stop offset="0.9942" stopColor="white" stopOpacity="0"></stop>
        </linearGradient>
        <linearGradient
          id="paint5_linear_910_24307"
          x1="177.979"
          y1="73.5281"
          x2="205.733"
          y2="84.4269"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E2E8F0"></stop>
          <stop offset="0.9942" stopColor="white" stopOpacity="0"></stop>
        </linearGradient>
        <linearGradient
          id="paint6_linear_910_24307"
          x1="126.455"
          y1="114.977"
          x2="126.435"
          y2="138.805"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white"></stop>
          <stop offset="0.9964" stopColor="#ECF0F5"></stop>
        </linearGradient>
        <linearGradient
          id="paint7_linear_910_24307"
          x1="133.937"
          y1="113.513"
          x2="143.929"
          y2="124.48"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BCCBE1"></stop>
          <stop offset="0.9942" stopColor="white" stopOpacity="0"></stop>
        </linearGradient>
        <linearGradient
          id="paint8_linear_910_24307"
          x1="105.97"
          y1="109.281"
          x2="121.764"
          y2="115.483"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E2E8F0"></stop>
          <stop offset="0.9942" stopColor="white" stopOpacity="0"></stop>
        </linearGradient>
      </defs>
    </svg>
  );
};

export default AccountDeletionIcon;

